/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './LayerDetails.scss';
import fetch from '../../../../../core/fetch';
import { changeLayerStyle, deleteGSLayer } from '../../../../../actions/district';
import ModalAlert from '../../../ModalAlert';

//fetchPgLayersList what is the path

class LayerDetails extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      currentLayer: 0,
      isStyleChanged: false,
      newStyleVal: '',
      showModal: false,
      inClickWindow: this.props.district.layers && this.props.district.layers.length > 0 ? this.props.district.layers[0].inClickWindow : null,
      inFloadinWindow: this.props.district.layers && this.props.district.layers.length > 0 ? this.props.district.layers[0].inFloadinWindow : null,
      arePropsChanged: false, // Depend on this state display save changes button
    };
  }

  onLayerChange = (e) => {
    this.setState({
      currentLayer: e.target.selectedIndex,
      isStyleChanged: false,
      inClickWindow: this.props.district.layers[e.target.selectedIndex].inClickWindow,
      inFloadinWindow: this.props.district.layers[e.target.selectedIndex].inFloadinWindow,
      arePropsChanged: false,
    });
  }

  onStyleChange = (e) => {
    if (this.props.district.layers[this.state.currentLayer].style) {
      if (this.props.district.layers[this.state.currentLayer].style.name !== e.target.value && e.target.value !== '') {
        this.setState({ isStyleChanged: true, newStyleVal: e.target.value });
      } else {
        this.setState({ isStyleChanged: false, newStyleVal: '' });
      }
    } else if (e.target.value !== '') {
      this.setState({ isStyleChanged: true, newStyleVal: e.target.value });
    } else {
      this.setState({ isStyleChanged: false, newStyleVal: '' });
    }
  }

  assignStyle = (e) => {
    this.props.changeLayerStyle(this.props.district.prefix, this.props.district.layers[this.state.currentLayer].name, this.state.newStyleVal)
    .then((resp) => {
      this.setState({ showModal: true, isStyleChanged: false, newStyleVal: null }, () => this.setState({ currentLayer: this.state.currentLayer }));
    });
  }

  dismissModal = () => this.setState({ showModal: false });

  onChangeInFlotingElement = (e) => this.setState({
    inFloadinWindow: e.target.checked,
    arePropsChanged: this.props.district.layers[this.state.currentLayer].inFloadinWindow !== e.target.checked || this.props.district.layers[this.state.currentLayer].inClickWindow !== this.state.inClickWindow,
  });

  onChangeInClickWindow = (e) => this.setState({
    inClickWindow: e.target.checked,
    arePropsChanged: this.props.district.layers[this.state.currentLayer].inClickWindow !== e.target.checked || this.props.district.layers[this.state.currentLayer].inFloadinWindow !== this.state.inFloadinWindow,
  });

  deleteLayer = () => {
    this.props.deleteGSLayer(this.props.district.prefix, this.props.district.layers[this.state.currentLayer].name);
  }

  render() {
    return this.props.district.layers && this.props.district.layers.length > 0 ? (
      <div className="col-xs-12">
        <div className="row">
          <div className="form-inline">
            <label className="col-sm-3" htmlFor="selectLayer">Warstwa</label>
            <select name="selectLayer" onChange={(e) => this.onLayerChange(e)} className="form-control" value={this.props.district.layers[this.state.currentLayer].name}>
              {this.props.district.layers.map((v, i) => {
                return <option key={i} value={v.name}> {String.prototype.normalizeLayerName(v.name)}</option>;
              })}
            </select>
          </div>
          <br />
        </div>
        <div className="row">
          <div className="form-inline">
            <label className="col-sm-3" htmlFor="layerName">Nazwa</label>
            <label className="col-sm-3" name="layerName">{this.props.district.layers[this.state.currentLayer].name}</label>
          </div>
        </div>

        <div className="row">
          <div className="form-inline">
            <label className="col-sm-3" htmlFor="layerName">Styl</label>
            <select
              name="selectLayer"
              className="form-control"
              onChange={(e) => this.onStyleChange(e)}
              value={(this.state.isStyleChanged) ? this.state.newStyleVal :
                ((this.props.district.layers[this.state.currentLayer].style)
                  ?
                  this.props.district.layers[this.state.currentLayer].style.name
                  :
                  '')}
            >
              <option key={0} value={null} />
              {this.props.district.styles.map((v, i) => {
                return <option key={i} value={v.name}> {v.name}</option>;
              })}
            </select>
            {this.state.isStyleChanged ? <button onClick={(e) => this.assignStyle(e)} type="submit" className="btn btn-info btnMargin">Przypisz styl</button> : null}
          </div>
        </div>

        <div className="row">
          <div className="form-inline">
            <label className="col-sm-12">
              <input
                type="checkbox"
                name="inFlotingElement"
                onChange={(e) => this.onChangeInFlotingElement(e)}
                checked={this.state.inFloadinWindow}
              />
              &nbsp;&nbsp;&nbsp;Wyświetl w pływającej chmurce
            </label>
          </div>
        </div>
        <div className="row">
          <div className="form-inline">
            <label className="col-sm-12">
              <input
                type="checkbox"
                name="displayOnClick"
                onChange={(e) => this.onChangeInClickWindow(e)}
                checked={this.state.inClickWindow}
              />&nbsp;&nbsp;&nbsp;Wyświetl po kliknięciu
            </label>
          </div>
        </div>

        <div className="row">
          <div className="form-inline">
            <label className="col-sm-12">
              <input
                type="checkbox"
                name="displayOnClick"
                onChange={(e) => this.onChangeInClickWindow(e)}
                checked={this.state.inClickWindow}
              />&nbsp;&nbsp;&nbsp;Warstwa niezależna od wyświetlanej kompozycji
            </label>
          </div>
        </div>

        {/*save changes button*/}
        {this.state.arePropsChanged ? (
          <div className="row">
            <div className="form-inline">
              <button type="submit" className="btn btn-primary" >Zapisz zmiany</button>
            </div>
          </div>
        ) : null}

        <div className="row">
          <div className="col-sm-5" />
          <div className="col-sm-2 text-center">
            <p className="boundingDesc">maxx</p>
          </div>
          <div className="col-sm-5" />
        </div>

        <div className="row">
          <div className="col-sm-3" />
          <div className="col-sm-2 text-center">
            <p className="boundingDesc">miny</p>
          </div>
          <div className="col-sm-2 text-center">
            <input className="form-control" type="text" value={this.props.district.layers[this.state.currentLayer].boundingbox.maxx} disabled />
          </div>
          <div className="col-sm-2 text-center">
            <p className="boundingDesc">maxy</p>
          </div>
          <div className="col-sm-3" />
        </div>

        <div className="row">
          <div className="col-sm-3" />
          <div className="col-sm-2 text-center">
            <input className="form-control" type="text" value={this.props.district.layers[this.state.currentLayer].boundingbox.miny} disabled />
          </div>
          <div className="col-sm-2 text-center">
            <p className="boundingDesc">minx</p>
          </div>
          <div className="col-sm-2 text-center">
            <input className="form-control" type="text" value={this.props.district.layers[this.state.currentLayer].boundingbox.maxy} disabled />
          </div>
          <div className="col-sm-3" />
        </div>

        <div className="row">
          <div className="col-sm-5" />
          <div className="col-sm-2 text-center">
            <input className="form-control" type="text" value={this.props.district.layers[this.state.currentLayer].boundingbox.minx} disabled />
          </div>
          <div className="col-sm-5" />
        </div>

        <div className="row">
          <div className="col-sm-12">
            <button onClick={() => this.deleteLayer()} type="submit" className="btn btn-warning btnMargin">Usuń warstwę</button>
          </div>
        </div>

        <div className="row">
          <table className="table">
            <thead>
              <tr>
                <th>id</th>
                <th>Nazwa atrybutu</th>
                <th>Typ danych</th>
              </tr>
            </thead>
            <tbody>
              {this.props.district.layers[this.state.currentLayer].attrs.map((v, i) => {
                return (
                  <tr key={i}>
                    <td>{i}</td>
                    <td>{v.nazwa}</td>
                    <td>{v.dataType}</td>
                  </tr>);
              })}

            </tbody>
          </table>
        </div>
        <ModalAlert
          title="Status akcji"
          bodyText={"Pomyślnie przypisano styl dla warstwy"}
          show={this.state.showModal}
          onHide={this.dismissModal}
        />
      </div>
    ) : <h2>Nie opublikowano żadnej warstwy do tej pory</h2>;
  }
}

const mapState = (state) => ({
  district: state.district.district,
});

const mapDispatch = {
  changeLayerStyle,
  deleteGSLayer,
};


export default withStyles(s)(connect(mapState, mapDispatch)(LayerDetails));



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/LayerDetails/LayerDetails.js